import { useAppStore } from "@/store/app";
import Postmate from "postmate";
import {
  IMediaCenterSelection,
  MediaCenterAllowedExtensions,
  MediaCenterCategory,
  mediaCenterEvents,
  MediaLibrarySettings,
} from "./mediaCenter.type";

export const triggerMediaCenterOpen = ({
  appHandshake,
  settings,
  onSelect,
}: {
  appHandshake: Postmate.Model;
  settings: MediaLibrarySettings;
  onSelect?: (data: IMediaCenterSelection) => void;
}) => {
  if (!appHandshake) {
    return;
  }

  if (onSelect) {
    const store = useAppStore();
    store.setPendingMediaCenterCallback(onSelect);
  }

  const updatedSettings: MediaLibrarySettings = {
    allowedExtensions: settings?.allowedExtensions || [
      MediaCenterAllowedExtensions.IMAGE,
    ],
    maxUploadSize: settings?.maxUploadSize || {},
    selfHosted: settings?.selfHosted || false,
    contentAi: settings?.contentAi || false,
    allowMultipleFileInsertion: settings?.allowMultipleFileInsertion || false,
    hideHeader: settings?.hideHeader || false,
    category: settings?.category || MediaCenterCategory.FORMS,
    subCategory: settings?.subCategory,
  };

  if (settings?.contentType) {
    updatedSettings.contentType = settings.contentType;
  }

  appHandshake.then((parent) =>
    parent.emit(mediaCenterEvents.MEDIA_CENTER_OPEN, updatedSettings)
  );
};
